import classNames from 'classnames'
import styles from './BaseModalFooter.module.scss'
import type { BaseModalFooterProps } from './types'

const BaseModalFooter = ({ className, children }: BaseModalFooterProps) => {
  return (
    <div className={classNames(styles['pintxo-modal__footer__slot'], className)}>{children}</div>
  )
}
export default BaseModalFooter
